import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=bf695018&scoped=true&"
import script from "./CreateCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomer.vue?vue&type=style&index=0&id=bf695018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf695018",
  null
  
)

component.options.__file = "CreateCustomer.vue"
export default component.exports